import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the RecordProcesses state domain
 */

const selectRecordProcessesDomain = (state) =>
  state.get("recordProcesses", initialState)

/**
 * Other specific selectors
 */
export const makeSelectProcessHistories = () =>
  createSelector(selectRecordProcessesDomain, (state) =>
    state.get("processHistories")
  )

export const makeSelectIsLoadingProcessHistories = () =>
  createSelector(selectRecordProcessesDomain, (state) =>
    state.get("isLoadingProcessHistories")
  )
/**
 * Default selector used by RecordProcesses
 */

const makeSelectRecordProcesses = () =>
  createSelector(selectRecordProcessesDomain, (substate) => substate.toJS())

export default makeSelectRecordProcesses
export { selectRecordProcessesDomain }
